import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { stardardRequest } from '../../utils';
import { API_BASE } from '../../constants/api.constant'

import {
  APPOINTMENT_SLOTS,
  COMMIT_LEAD,
  LEADS_FETCH_BY_ID,
} from '../actions';

export function* watchLeadsFetchIdRequest() {
  const action = LEADS_FETCH_BY_ID
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      return {
        method: 'get',
        url: `${API_BASE}/v1/public/lead/${payload.id}`
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export function* watchGetApppointments() {
  const action = APPOINTMENT_SLOTS
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptions: {
      method: 'get',
      url: `${API_BASE}/v1/public/appointment-slots`,
    },
    dataPath: 'results',
    dataDefault: [],
  }));
}

export function* watchCreateLeadAppt() {
  const action = COMMIT_LEAD
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptions: {
      method: 'post',
      url: `${API_BASE}/v1/public/commit`,
    },
    requestOptionsFromPayload: (payload) => {
      return {
        data: payload
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export default function* rootSaga() {
  yield all([
    fork(watchLeadsFetchIdRequest),
    fork(watchGetApppointments),
    fork(watchCreateLeadAppt),
  ]);
}